<label
  *ngIf="!downloadLink"
  [for]="inputId"
  class="logo-card-upload m-0 position-relative"
  [ngClass]="{ 'drag-file-area': isHoverFile }"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (dragleave)="onDragLeave($event)"
>
  <loading-spinner [show]="isLoading || isUploadingDoc"></loading-spinner>
  <div class="upload-image-card">
    <div class="upload-image-card__left p-3">
      <span class="upload-image-card__icon" [ngClass]="{ sm: isSm }">
        <i class="fa fa-paperclip" aria-hidden="true"></i>
        <span class="upload-image-card__icon-normal">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </span>
      </span>
      <div class="upload-image-card__middle">
        <div class="upload-image-card__description-header" [ngClass]="{ 'justify-content-between': (isTablet$ | async) }">
          <span class="value">{{ headerLabel | translate }}</span>
          <span class="optional-label" [ngClass]="badgeClass">{{ badgeLabel | translate }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex">
            <div class="upload-image-card__mobile-icon">
              <i class="fa plus fa-plus" aria-hidden="true"></i>
            </div>
            <div class="upload-image-card__description">
              <div class="upload-image-card__description-hint" [innerHTML]="descriptionHint | translate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-image-card__right d-flex align-items-center p-3" *ngIf="!(isTablet$ | async)">
      <span class="upload-image-card__drag-area">
        <span [innerHTML]="footerHint | translate"></span>
      </span>
    </div>
  </div>
</label>

<input
  *ngIf="!downloadLink"
  #inputElement
  [id]="inputId"
  class="d-none"
  type="file"
  (click)="clickInput()"
  (change)="handleFiles($event)"
  [disabled]="!!downloadLink"
  [attr.accept]="acceptAttribute"
/>
<app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>

<ng-template [ngIf]="downloadLink">
  <div class="position-relative">
    <loading-spinner [show]="isLoading || isUploadingDoc"></loading-spinner>
    <div
      class="uploaded-image-container"
      [ngClass]="{ 'drag-file-area': isHoverFile }"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
      (dragleave)="onDragLeave($event)"
    >
      <div class="d-flex">
        <div class="uploaded-image-container__image">
          <img *ngIf="!isNonImage" [src]="downloadLink" height="160" />
          <span *ngIf="isNonImage" class="uploaded-image-container__placeholder-icon">
            <i class="fa" [ngClass]="nonImageIconClass" aria-hidden="true"></i>
            <span class="uploaded-image-container__placeholder-icon-check">
              <i class="fa fa-check" aria-hidden="true"></i>
            </span>
          </span>
        </div>
        <span class="uploaded-image-container__file-name" [class.clickable]="isDownloadableUrl" (click)="downloadFile($event)">
          {{ displayFileName || (uploadedFileLabel | translate) }}
        </span>
      </div>
      <div class="d-flex" *ngIf="showRemoveButton && !isNonImage">
        <span class="uploaded-image-container__remove">
          <span class="uploaded-image-container__remove-icon" (click)="removeFile($event)">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </span>
        </span>
      </div>
      <div class="d-flex" *ngIf="!showRemoveButton">
        <span class="uploaded-image-container__remove">
          <label [for]="replaceInputId" class="uploaded-image-container__remove-icon m-0">
            <i class="fa fa-upload" aria-hidden="true"></i>
          </label>
          <input
            #replaceInputElement
            [id]="replaceInputId"
            class="d-none"
            type="file"
            (click)="clickReplaceInput()"
            (change)="handleReplaceFiles($event)"
            [attr.accept]="acceptAttribute"
          />
        </span>
      </div>
    </div>
  </div>
</ng-template>
